import type { ReactNode } from 'react';
import { ExportStatusIcon } from 'widgets/home/ExportStatusIcon';
import { ExportStatusUpdater } from 'widgets/resultCard/ExportStatusUpdater';
import {
  CardHeader,
  CardInfo,
  ChevronRightIcon,
  StatusContainer,
  StatusIconContainer,
  StyledResultCard,
} from 'widgets/resultCard/ResultCard.styles';
import type { ExportStatus, ExportStatusValue } from 'types/result';

interface ResultCardShellProps {
  resultId: number;
  currentStatus?: ExportStatusValue;
  onStatusUpdate: (updatedStatus: ExportStatus) => void;
  onClick: () => void;
  ariaLabel: string;
  infoLine: string;
  isError: boolean;
  maskAnalytics?: boolean;
  children: ReactNode;
}

export const ResultCardShell = ({
  resultId,
  currentStatus,
  onStatusUpdate,
  onClick,
  ariaLabel,
  infoLine,
  isError,
  maskAnalytics = false,
  children,
}: ResultCardShellProps) => (
  <div role="presentation">
    <ExportStatusUpdater
      resultId={resultId}
      currentStatus={currentStatus}
      onUpdate={onStatusUpdate}
    />
    <StyledResultCard
      role="button"
      data-ph-no-autocapture={maskAnalytics || undefined}
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick();
        }
      }}
      aria-label={ariaLabel}
    >
      <CardHeader>
        <CardInfo $isError={isError}>{infoLine}</CardInfo>
        <StatusContainer>
          <StatusIconContainer>
            <ExportStatusIcon status={currentStatus} />
          </StatusIconContainer>
          <ChevronRightIcon />
        </StatusContainer>
      </CardHeader>
      {children}
    </StyledResultCard>
  </div>
);
